const Express_URL = "https://www.americanyachtgroupinternational.com/api";
//const Express_URL = "http://3.19.190.75:5003/api";
//const Express_URL = "http://18.116.55.78/api";
//const Express_URL = "http://localhost:5001/api";

export default Express_URL;
